import $ from 'jquery';
import deferAction from 'scripts/utils/deferAction';
import {GASearch} from "../ga/search";
import { allowedLocales } from 'scripts/utils/constants';

const AJAX = '';
let locale = $('html').attr('lang');
if (!(locale in allowedLocales)) {
  locale = allowedLocales.uk;
}

const layout = (response) =>{
  const template = `
    <div class="modal modal-search" data-target='modal-search'>
      <div class="modal__zoom">
        <div class="modal-content">
          <div class="search-content">
            <div class="search-content__input">
              <button class="button">
                <svg class="icon-search"><use xlink:href="#search"/></svg>
              </button>
              <input type="text" id="modal-search-input" placeholder="${response.title}">
              <div class="close"></div>
            </div>
            <div class="search-content__dropdown flex-s">
            </div>
            <div class="search-not_found">
              ${response.not_found}
            </div>
            <a href="#" class="search-content__more flex-c-c">
              ${response.all_result}
            </a>
          </div>
        </div>
      </div>
    </div>`;

  $("body").append(template);
  $('.modal-search').fadeIn(300);
  $('html').addClass('overflow');
  $('#modal-search-input').focus();
}

const modalSearch = {
  call: function createTemplate (){
    $.get(`${AJAX}/api/get_form_data?locale=${locale}&action=search`, ({common}) =>{
      layout(common)
    });
    
  }
}

const searchQuery = () =>{
  let timeout;
  let template = [];
  const createLayout = productsArr => {
    template = [];

    productsArr.forEach(item => {
      const oldPrice = item.format_old_price;
      const card = `
        <a href="${item.slug}" class="cart-card flex-s">
            <div class="cart-card__img flex-c-c">
                <img src="${item.preview_image}" alt="">
            </div>
            <div class="cart-card__content flex-c">
                <div class="cart-card__info">
                    <div class="name">
                        ${item.name_without_brand}
                    </div>
                </div>
                <div class="cart-card__price">
                    <div class="price">
                        ${item.format_price}
                    </div>
                    ${
                      (oldPrice !== '' && oldPrice !== undefined && oldPrice !== null && oldPrice)? `<div class="price-old">${oldPrice}</div>` : ''
                    }
                </div>
            </div>
        </a>`;
      template.push(card);
    });
  };

  $(document).on('keyup change', '.modal .search-content__input input', function closeDropdown(e){
    const $this = $(this);
    const val = $this.val();
    const parent = $this.parents('.search-content');

    clearTimeout(timeout);

    if(val === ''){
      parent.removeClass('active empty');
    }else if(val.length >= 2 ){
      const lang = locale === 'ru'? '': `/${locale}`;
      if (e.which === 13) {
        window.location.href = `${lang}/search/?q=${val}`;
        return;
      }
      timeout = setTimeout(() => {
        $.get(`${AJAX}${lang}/api/async_search/`, {q: val}, ({products}) => {
          if(products.length){
            createLayout(products);
          }
        }).done(({products}) => {
          GASearch(val);
          if(products.length){
            $('.modal .search-content__dropdown').html(template);
            parent.addClass('active').removeClass('empty');
          }else{
            parent.addClass('empty').removeClass('active');
          }
        });
      }, 1000);

      $('.modal .search-content__more').attr('href',`${lang}/search/?q=${val}`);
    }
  }).on('click', '.close', function removeValue(){
    const $this = $(this);

    $('.modal').fadeOut(300);
    
    deferAction(() => {
      $this.siblings('input').val('').change();
      $('html').removeClass('overflow');
    })
  });
}
searchQuery();

export default modalSearch